var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('a',{staticClass:"title_link",staticStyle:{"text-decoration":"none"},attrs:{"href":"/glyf"}},[_c('img',{staticStyle:{"height":"70px"},attrs:{"src":require("../../assets/glyf_logo.jpg")}}),_c('span',{staticStyle:{"position":"relative","bottom":"25px","left":"15px"}},[_vm._v("管理有方 | 管理痛点库")])])])
}]

export { render, staticRenderFns }